const mealsPopUpTranslations = {
    ingredients:'Ingredients',
    salad:'Salad',
    actionButton:'Mark Completed',
    cancel:'Cancel',
    description:'Preparation Description',
    disCancel:'Cancel'
}

export default  mealsPopUpTranslations;